import { useEffect, useState } from "react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  ["chales", "Chalés"],
  ["experiencia", "Experiência"],
  ["reservar", "Reservar"],
  ["contato", "Contato"],
];

export default function Header() {
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > window.innerHeight * 0.75);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,color] duration-500 ${
        solid ? "bg-[#faf7f2]/85 text-[#163323] shadow-[0_1px_0_#e2ded6] backdrop-blur-xl" : "bg-transparent text-[#faf7f2]"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <button data-testid="header-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3">
          <img src={solid ? "/img/logo-green.png" : "/img/logo-white.png"} alt="Reserva Mantiqueira" className="h-11 w-11 object-contain" />
          <span className="hidden text-sm font-bold uppercase tracking-[0.25em] sm:inline">Reserva Mantiqueira</span>
        </button>
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => scrollToId(id)}
              className="group relative text-xs font-bold uppercase tracking-[0.22em]"
            >
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-current transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <button
          data-testid="header-reserve-btn"
          onClick={() => scrollToId("reservar")}
          className={`rounded-full px-5 py-2.5 text-xs font-bold uppercase tracking-[0.2em] transition-colors duration-300 ${
            solid ? "bg-[#163323] text-[#faf7f2] hover:bg-[#a4532f]" : "bg-[#faf7f2] text-[#163323] hover:bg-[#e9c9a8]"
          }`}
        >
          Reservar
        </button>
      </div>
    </header>
  );
}
